<script setup>
import { computed, ref, onMounted, onBeforeMount, inject } from 'vue'
import { useRoute } from 'vue-router'
import { useMenuStore } from '@/store/modules/menuStore'

const openTab = inject('openTab') // ✅ función inyectada desde App.vue o Layout
const route = useRoute()
const getRoute = () => route.path.split('/')[1]

const menuStore = useMenuStore()
const menus = computed(() => menuStore.menus)

const seccionesAbiertas = ref([])

onBeforeMount(async () => {
    const token = sessionStorage.getItem('token')
    if (!token) return

    if (!menus.value || !Object.keys(menus.value).length) {
        await menuStore.loadMenus()
    }
})

onMounted(() => {
    const grupos = Object.values(gruposFiltrados.value)

    seccionesAbiertas.value = grupos
        .map((grupo, index) => {
            if (!Array.isArray(grupo)) {
                console.warn(`❌ El grupo en el índice ${index} NO es un array:`, grupo)
                return null
            }

            try {
                const activa = grupo.some(menu => getRoute() === menu.adme_ruta)
                return activa ? index : null
            } catch (e) {
                console.error(`❌ Error en grupo[${index}] al hacer .some():`, grupo, e)
                return null
            }
        })
        .filter(i => i !== null)
})



const toggleSeccion = (index) => {
    const i = seccionesAbiertas.value.indexOf(index)
    if (i > -1) {
        seccionesAbiertas.value.splice(i, 1)
    } else {
        seccionesAbiertas.value = [index]
    }
}

const gruposFiltrados = computed(() => {
    const obj = {}
    for (const seccion in menus.value) {
        obj[seccion] = menus.value[seccion].filter(menu => menu.adme_ruta)
    }
    return obj
})

function handleOpenTab(menu) {
    if (!openTab) {
        console.warn('openTab no está disponible')
        return
    }

    if (!menu.adme_nombre || !menu.adme_ruta) return

    const ruta = '/' + menu.adme_ruta.replace(/\./g, '/')
    const fullUrl = process.env.VUE_APP_URL_FRONTEND + ruta
    // const fullUrl = window.location.origin + ruta
    openTab(menu.adme_nombre, fullUrl)

}
</script>

<template>
    <div class="accordion accordion-flush" id="accordionMenu">
        <div class="accordion-item border-0" v-for="(grupo, seccion, index) in gruposFiltrados" :key="seccion">
            <!-- Sección encabezado -->
            <div class="d-flex justify-content-between align-items-center text-uppercase text-xs font-weight-bolder opacity-6 mb-2 ps-3 pe-3 mt-3"
                @click="toggleSeccion(index)" style="cursor: pointer;">
                <div>{{ seccion }}</div>
                <i class="ni" :class="seccionesAbiertas.includes(index) ? 'ni-bold-down' : 'ni-bold-right'"></i>
            </div>

            <!-- Menú hijos -->
            <ul class="nav flex-column ms-4" v-show="seccionesAbiertas.includes(index)">
                <li v-for="menu in grupo" :key="menu.adme_id" class="nav-item" @click="handleOpenTab(menu)">
                    <a href="#" class="nav-link text-sm d-flex align-items-center py-2 px-3 rounded"
                        style="transition: all 0.2s ease-in-out;" @mouseover="hover = true" @mouseleave="hover = false">
                        <i :class="`${menu.adme_icono} text-primary me-2`" style="font-size: 1rem;" />
                        {{ menu.adme_nombre }}
                    </a>

                </li>
            </ul>
        </div>
    </div>
</template>
